<template>
  <div class="content content-narrow plant-detail">
    <div class="col-12 gt-details">
      <div class="block">
        <div v-if="showLoader" class="overlay"></div>
        <hash-loader v-if="showLoader" class="hash-icon table-hash-icon" color="#9eb89f" loading="loading" size="40" sizeUnit="px"></hash-loader>
        <div class="block-header bg-light">
            <h3 class="block-title text-white"><i class="fa text-muted fa-object-group text-white"></i> Plant Batch Details</h3>
          <div class="blok-title text-white text-right">
            <router-link to="/plantbatch" title="Go back" class="js-tooltip-enabled text-white">
              <i class="fa fa-angle-double-left text-white"></i> Back
            </router-link>
          </div>
        </div>
        <div class="block-content block-content-full">
          <div class="row">
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Id</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plantBatch.Id }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Name</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plantBatch.Name }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Type</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plantBatch.Type }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Planted Date</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plantBatch.PlantedDate }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Last Modified</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(plantBatch.LastModified) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Count</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plantBatch.Count }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Untracked Count</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plantBatch.UntrackedCount }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Tracked Count</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plantBatch.TrackedCount }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Live Count</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plantBatch.LiveCount }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Packaged Count</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plantBatch.PackagedCount }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Harvested Count</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plantBatch.HarvestedCount }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Destroyed Count</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plantBatch.DestroyedCount }}</div>
            <div class="col-12 border-top"></div> 
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Source Package ID</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(plantBatch.SourcePackageId) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Source Package Label</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(plantBatch.SourcePackageLabel) }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Source Plant ID</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(plantBatch.SourcePlantId) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Source Plant Label</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(plantBatch.SourcePlantLabel) }}</div>
          </div>
        </div>
        <div class="block-header bg-light">
          <h3 class="block-title text-white"><i class="fa fa-cannabis"></i> Assigned Strain</h3>
        </div>
        <div class="block-content block-content-full">
          <div class="row">
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Strain Id</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plantBatch.StrainId }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Strain Name</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plantBatch.StrainName }}</div>
          </div>
        </div>
        <div class="block-header bg-light">
          <h3 class="block-title text-white"><i class="fa fa-door-open"></i> Assigned Room</h3>
        </div>
        <div class="block-content block-content-full">
          <div class="row">
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Room Id</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(plantBatch.RoomId)  }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Room Name</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(plantBatch.RoomName) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { helper } from '@/helper.js';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
Vue.use(VueSpinners);

export default {
  name: 'PlantBatchDetails',
  data() {
    return {
      plantBatch: {
        Id: 0,
        Name: 'null',
        Type: 'null',
        PlantedDate: 'null',
        LastModified: '',
        UntrackedCount: 0,
        TrackedCount: 0,
        Count: 0,
        LiveCount: 0,
        PackagedCount: 0,
        HarvestedCount: 0,
        DestroyedCount: 0,
        SourcePackageId: 0,
        SourcePackageLabel: '',
        SourcePlantId: 0,
        SourcePlantLabel: '',
        StrainId: 0,
        StrainName: 'null',
        RoomId: 0,
        RoomName: ''
      },
      showLoader: false
    };
  },
  mounted() {
    let vm = this;
    vm.showLoader = true;
    helper.sendPostRequest('/plantbatches/get', { id: vm.$route.params.id})
      .then((data) => {
        vm.showLoader = false;
        if (data.status === 'success') {
          vm.plantBatch = data.data;
        } else {
          vm.$router.push('/plantbatch');
        }
      });
  },
  components: {
    HashLoader
  },
  methods: {
    getDate(dateText) {
      if (dateText === '') {
        return 'null';
      }
      let date = new Date(dateText).toISOString().substr(0, 19).replace('T', ' ');
      return date;
    },
    getValue(value) {
      if (!value) {
        return 'null';
      }
      return value;
    }
  }
};
</script>

<style>
.plant-detail .block-content {
  word-wrap: break-word;
}
.hidden-border {
  display: block;
}
.border-top {
  margin: 10px 0;
}
@media only screen and (min-width: 575px) {
  .hidden-border {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// source/components/PlantBatchDetails.vue